<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
    @if (item && item.title) {
      <ion-title class="ion-text-center">
        {{item.title}}
        @if (item.subtitle) {
          <p class="subtitle">{{item.subtitle}}</p>
        }
      </ion-title>
    }
    @if (item && cart && item.sell_price !== null && item.quantity !== null && item.discount_amount !== null) {
      <ion-buttons slot="end">
        <ion-button  (click)="confirmationClicked()">
          <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
        </ion-button>
      </ion-buttons>
    }
  </ion-toolbar>

  <ion-segment color="primary" [(ngModel)]="segment">
    <ion-segment-button value="pricing" checked>
      <ion-label>Pricing</ion-label>
    </ion-segment-button>
    <ion-segment-button value="notes">
      <ion-label>Notes</ion-label>
    </ion-segment-button>
  </ion-segment>

</ion-header>

@if (item && cart) {
  <ion-content [ngClass]="{'on-device': on_device == true, 'not-on-device': on_device == false}">
    @switch (segment) {
      @case ('pricing') {
        <ion-grid class="ion-no-padding pricing">
          <ion-row>
            <ion-col>
              <ion-grid class="ion-no-padding inputs">
                <ion-row class="ion-align-items-center ion-justify-content-center">
                  <ion-col size="8">
                    Price
                    @if (item.has_custom_price) {
                      <span class="price-note">Custom</span>
                    }
                    @if (item.has_contract_price) {
                      <span class="price-note">Contract</span>
                    }
                    @if (item.has_volume_discount) {
                      <span class="price-note">Volume discount</span>
                    }
                    @if (item.comparison_price_percentage_difference > 0) {
                      <span class="negative" style="font-size: 14px; display:block; ">({{item.comparison_price_percentage_difference | number:'1.2'}}% off {{cart.currency.sign}}{{item.comparison_price | number:'1.2'}} comparison price)</span>
                    }
                  </ion-col>
                  @if (permissionService.isPermitted('pos-sell-edit-item-price')) {
                    <ion-col size="4" class="input price">
                      <span>{{cart.currency.sign}}</span>
                      <ion-input type="tel" inputmode="decimal" maxlength="10" label="" aria-label="Price" [(ngModel)]="item_sell_price" (ngModelChange)="sanitiseItemSellPrice()" (keydown.enter)="enterPressed()"></ion-input>
                      @if (canSaveContractPrice()) {
                        <div class="contract-price">
                          <ion-toggle class="contract-price-toggle" labelPlacement="start" justify="start" [(ngModel)]="save_contract_price">
                            @if (initial_item.has_contract_price) {
                              Update contract price
                            }
                            @else {
                              Save as contract price
                            }
                          </ion-toggle>
                        </div>
                      }
                    </ion-col>
                  }
                  @if (!permissionService.isPermitted('pos-sell-edit-item-price')) {
                    <ion-col size="4">
                      <p style="text-align: right;">{{cart.currency.sign}}{{item_sell_price | number:'1.2'}}</p>
                    </ion-col>
                  }
                </ion-row>
                @if (is_donation_or_voucher == false) {
                  <ion-row class="ion-align-items-center">
                    <ion-col size="8">Quantity@if (item.measurement_unit) {
                      ({{item.measurement_unit.symbol}})
                    }</ion-col>
                    <ion-col size="4" class="input quantity">
                      <fa-icon [icon]="['fas', 'minus']" (click)="adjustItemQuantity('subtract')"></fa-icon>
                      <ion-input type="tel" inputmode="decimal" maxlength="10" class="ion-text-center" label="" aria-label="Quantity" [(ngModel)]="item_quantity" (ngModelChange)="sanitiseItemQuantity()" (keydown.enter)="enterPressed()"></ion-input>
                      <fa-icon [icon]="['fas', 'plus']" (click)="adjustItemQuantity('add')"></fa-icon>
                    </ion-col>
                  </ion-row>
                }
                @if (is_donation_or_voucher == false) {
                  <ion-row class="ion-align-items-center">
                    <ion-col size="8">Discount</ion-col>
                    @if (permissionService.isPermitted('pos-sell-edit-item-discount')) {
                      <ion-col size="4" class="input discount">
                        <span [ngClass]="{'selected': item.discount_type == 'fixed_amount'}" (click)="adjustItemDiscountType('fixed_amount')">{{cart.currency.sign}}</span>
                        <span [ngClass]="{'selected': item.discount_type == 'percentage'}" (click)="adjustItemDiscountType('percentage')">%</span>
                        <ion-input type="tel" inputmode="decimal" maxlength="10" label="" aria-label="Discount" [(ngModel)]="item_discount_amount" (ngModelChange)="sanitiseItemDiscountAmount()" (keydown.enter)="enterPressed()"></ion-input>
                      </ion-col>
                    }
                    @if (!permissionService.isPermitted('pos-sell-edit-item-discount')) {
                      <ion-col size="4">
                        @if (item.discount_type == 'fixed_amount') {
                          <p style="text-align: right;">{{cart.currency.sign}}{{item_discount_amount | number:'1.2'}}</p>
                        }
                        @if (item.discount_type == 'percentage') {
                          <p style="text-align: right;">{{item_discount_amount | number:'1.2'}}%</p>
                        }
                      </ion-col>
                    }
                  </ion-row>
                }
              </ion-grid>
            </ion-col>
          </ion-row>
          @if (item.sell_price !== null && item.quantity !== null && item.discount_amount !== null && item.quantity > 0) {
            <ion-row>
              <ion-col>
                <table class="datatable compact">
                  <tr>
                    <td class="border-top">Subtotal</td>
                    <td class="border-top ion-text-right ion-text-nowrap">{{item.quantity}} x {{cart.currency.sign}}{{item.sell_price | number:'1.2'}} = {{cart.currency.sign}}{{item.sell_subtotal_amount | number:'1.2'}}</td>
                  </tr>
                  <tr>
                    <td>Discount</td>
                    <td class="ion-text-right ion-text-nowrap">
                      @if (item.discount_price > 0) {
                        @if (item.discount_type == 'percentage') {
                          {{item.discount_amount}}% off =
                          }–
                          }{{cart.currency.sign}}{{item.discount_price | number:'1.2'}}
                        </td>
                      </tr>
                      <tr>
                        <td class="double-border">TOTAL</td>
                        <td class="ion-text-right ion-text-nowrap double-border">{{cart.currency.sign}}{{item.total_price | number:'1.2'}}</td>
                      </tr>
                      @if (permissionService.isPermitted('pos-sell-view-item-price-breakdown') && (item.cost_price && auto_hide_price_breakdown == false)) {
                        <tr>
                          <td>Total cost</td>
                          <td class="ion-text-right ion-text-nowrap">{{item.quantity}} x –{{cart.currency.sign}}{{item.cost_price | number:'1.2'}} = –{{cart.currency.sign}}{{item.cost_subtotal_amount | number:'1.2'}}</td>
                        </tr>
                        <tr>
                          <td>Inclusive tax</td>
                          <td class="ion-text-right ion-text-nowrap">–{{cart.currency.sign}}{{item.inclusive_tax_price | number:'1.2'}}</td>
                        </tr>
                        <tr>
                          <td class="double-border">PROFIT</td>
                          <td class="ion-text-right ion-text-nowrap double-border">
                            @if (item.profit <= 0) {
                              <span class="negative">–{{cart.currency.sign}}{{item.profit | number:'1.2' | replace: '-' : ''}}</span>
                            }
                            @if (item.profit > 0) {
                              <span class="positive">{{cart.currency.sign}}{{item.profit | number:'1.2' }}</span>
                            }
                          </td>
                        </tr>
                        @if (item_sell_price > 0) {
                          <tr>
                            <td>MARGIN</td>
                            <td class="ion-text-right ion-text-nowrap">
                              @if (item.margin == 0) {
                                <span class="negative">{{item.margin | number:'1.2'}}%</span>
                              }
                              @if (item.margin < 0) {
                                <span class="negative">–{{item.margin | number:'1.2' | replace: '-' : ''}}%</span>
                              }
                              @if (item.margin > 0) {
                                <span class="positive">{{item.margin | number:'1.2'}}%</span>
                              }
                            </td>
                          </tr>
                        }
                      }
                    </table>
                  </ion-col>
                </ion-row>
                @if (permissionService.isPermitted('pos-sell-view-item-price-breakdown')) {
                  @if (auto_hide_price_breakdown == true) {
                    <ion-row class = "price-breakdown-toggle" (click)="togglePriceBreakdown()">
                      <ion-col>
                        <fa-icon [icon]="['far', 'eye']" size="med" [fixedWidth]="true"></fa-icon>Show price breakdown
                      </ion-col>
                    </ion-row>
                  }
                  @if (auto_hide_price_breakdown == false) {
                    <ion-row class = "price-breakdown-toggle" (click)="togglePriceBreakdown()">
                      <ion-col>
                        <fa-icon [icon]="['far', 'eye-slash']" size="med" [fixedWidth]="true"></fa-icon>Hide price breakdown
                      </ion-col>
                    </ion-row>
                  }
                }
              }
            </ion-grid>
          }
          @case ('notes') {
            <ion-grid class="form">
              <ion-row>
                <ion-col>
                  <ion-grid class="fieldset">
                    <ion-row>
                      <ion-col>
                        <ion-textarea #customer_note_input type="text" inputmode="text" [autoGrow]="true" maxlength="1000" rows="5" labelPlacement="stacked" fill="outline" [(ngModel)]="item.customer_note">
                          <div slot="label">Note for customer<ion-text class="optional">optional</ion-text></div>
                        </ion-textarea>
                      </ion-col>
                    </ion-row>
                    <ion-row>
                      <ion-col>
                        <ion-textarea type="text" inputmode="text" [autoGrow]="true" maxlength="1000" rows="5" labelPlacement="stacked" fill="outline" [(ngModel)]="item.internal_note">
                          <div slot="label">Internal note<ion-text class="optional">optional</ion-text></div>
                        </ion-textarea>
                      </ion-col>
                    </ion-row>
                  </ion-grid>
                </ion-col>
              </ion-row>
            </ion-grid>
          }
        }
      </ion-content>
    }
